import React from 'react';
import PropTypes from 'prop-types';

import Translate from '@hydra/common/components/i18n';
import CriteriumTable from '@hydra/common/criterium/CriteriumTable';
import Criterium from '@hydra/common/criterium/Criterium';
import SafeAnchor from '@hydra/common/components/SafeAnchor';

export const ResourcesCacheability = ({ criterium }) => {
  const { data } = criterium;
  const uncachedResources = data.uncachedResources || [];

  const head = [
    <Translate content='url' key='url' />,
    <Translate content='freshness_lifetime' key='freshness_lifetime' />
  ];

  const body = uncachedResources.map(({ freshnessLifetime, url }) => ([
    <SafeAnchor
      rel='nofollow noopener noreferrer'
      title={url} target='_blank' href={url}
      key={url}
    >
      {url}
    </SafeAnchor>,
    <span key='freshnessLifetime'>
      {
        freshnessLifetime || <Translate content='expiration_not_specified' />
      }
    </span>
  ]));

  const content = uncachedResources.length === 0
    ? <Translate content='resources_cacheability_ok' />
    : (
      <>
        <Translate
          content='resources_cacheability_nok'
          with={{ count: uncachedResources.length }}
        />
        <CriteriumTable
          head={head}
          rows={body}
          fixedColumns={[3, 2]}
          thinHead
          striped
          nowrap
        />
      </>
      );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

ResourcesCacheability.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.object
  })
};

export default React.memo(ResourcesCacheability);
